<template>
  <div class="custom-card">
    <v-toolbar-title class="mb-4 py-2" style="border-bottom: 1px solid #d4dbe0">
      <v-row dense>
        <v-col cols="12" md="6" lg="6">
          <span>COMISIONES: {{ nombreRecurso }}</span>
        </v-col>
      </v-row>
    </v-toolbar-title>

    <v-row dense>
      <v-col cols="12" md="9" xl="10">
        <v-btn class="mx-1" title="Recargar" small @click="listar">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>

        <v-btn
          class="mx-1"
          title="Establecer Sede Talento Humano"
          small
          :disabled="itemSeleccionado == null"
          @click="$refs.modalFormularioSedes.abrir(acciones.EDITAR, itemSeleccionado)">
          <v-icon>mdi-account-tie</v-icon>
          Establecer Sede Talento Humano
        </v-btn>
      </v-col>

      <v-col cols="12" md="3" xl="2">
        <v-text-field
          dense
          outlined
          hide-details
          v-model="busqueda"
          append-icon="mdi-magnify"
          label="Buscar"
          clearable
          @input="buscar"></v-text-field>
      </v-col>

      <v-col cols="12">
        <ListadoSedes ref="listadoRef" :rowData="items" :cargando="cargando" @seleccionarItem="seleccionarItem" />
      </v-col>
    </v-row>

    <ModalFormularioSedes ref="modalFormularioSedes" nombreItem="Sede" @actualizarListado="listar" />

    <notifications group="notifications" position="top right" />
  </div>
</template>

<script>
import layoutMixin from '../mixins/layout.mixin';
import apiConsumerMixin from '../mixins/api-consumer.mixin';
import SedesService from '../services/sedes.service';
import ListadoSedes from './components/ListadoSedes';
import ModalFormularioSedes from './components/ModalFormularioSedes';
import { ACCIONES } from '../utils/constantes';

export default {
  name: 'SedesLayout',
  mixins: [layoutMixin, apiConsumerMixin],
  components: {
    ListadoSedes,
    ModalFormularioSedes,
  },
  data() {
    return {
      nombreRecurso: 'SEDES',
      acciones: ACCIONES,
    };
  },
  mounted() {
    this.listar();
  },
  methods: {
    async listar() {
      await this.findAllMixin(
        SedesService.findAll,
        null,
        this.nombreRecurso,
        () => {
          this.items = [];
          this.itemSeleccionado = null;
          this.cargando = true;
        },
        () => {
          this.cargando = false;
        },
        (datos) => {
          this.items = datos;
        },
        () => {
          this.items = [];
          this.itemSeleccionado = null;
        },
      );
    },
  },
};
</script>

<style scoped>
.custom-card {
  border: 1px solid #dfdfdf;
  padding: 8px;
  margin: 0px 8px 0px 8px;
}

::v-deep .v-select.v-text-field--outlined:not(.v-text-field--single-line).v-input--dense .v-select__selections {
  padding: 0px 0;
}

::v-deep .v-text-field .v-input__control .v-input__slot {
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
}

::v-deep .v-text-field--outlined.v-input--dense .v-label {
  top: 5px;
}

::v-deep .v-text-field .v-label {
  font-weight: 400;
}
</style>
